<template>
  <dialog-add
    icon="inventory"
    :title="$t('create_event_asset')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-events-asset class="elevation-1" @saved="$emit('saved')" />
    </template>
  </dialog-add>
</template>

<script>
export default {
  emits: ['saved'],
  methods: {
    onCancel() {
      this.$router.push({ name: 'event-assets', query: this.$route.query });
    },
  },
};
</script>
